import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';

import { ExternalLink } from './StyledComponents/Links';

const StyledFooter = styled.footer`
	.social a {
		font-family: var(--font-heading);
	}

	.social a::after {
		background-color: transparent;
	}
`;

const Footer = () => {
	const data = useStaticQuery(graphql`
		query SocialQuery {
			site {
				siteMetadata {
					social {
						github
						twitter
						linkedin
					}
				}
			}
		}
	`);

	const {
		social: { github, twitter, linkedin },
	} = data.site.siteMetadata;

	return (
		<StyledFooter className="border-t-1">
			<div className="social flex py-4 md:py-8 text-sm md:text-base">
				<ExternalLink href={github} className="mr-8 font-extrabold">
					Github
				</ExternalLink>
				<ExternalLink href={twitter} className="mr-8 font-extrabold">
					Twitter
				</ExternalLink>
				<ExternalLink href={linkedin} className="mr-8 font-extrabold">
					LinkedIn
				</ExternalLink>
			</div>
			<div className="copyright text-xs md:text-sm">
				© {new Date().getFullYear()}
				{` `}
				Mohit Yadav
			</div>
		</StyledFooter>
	);
};

export default Footer;
